module.exports = __webpack_public_path__ + "static/img/miyazawa_01.e086cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miyazawa_01.png
// module id = MAnZ
// module chunks = 0